import React, { useState } from "react";

import "./index.scss";

import { getGradeforRiskprofile } from "api/grade";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const Scorefield = (props) => {
  const { selectedData, show, input_fields, val, name, score, grade, module, card_fields,  approvalQuiz } = props;


  const [gradeLevel, setGradeLevel] = useState(selectedData?.grade);

  const dispatch = useDispatch();
  const eval_expression = input_fields[0].name;
  const evalExp = () => {
    const evalData = eval(eval_expression);
    return evalData;
  };


  const getBGColorBasedOnGrade = (gradeLevel) => {
    if (gradeLevel === "Secure") {
      return <span className="cardstyle risk_average">Secure</span>;
    } else if (gradeLevel === "Conservative") {
      return <span className="cardstyle risk_conservative">Conservative</span>;
    } else if (gradeLevel === "Moderate") {
      return <span className="cardstyle risk_moderate">Moderate</span>;
    } else  if (gradeLevel === "Growth")  {
      return <span className="cardstyle risk_growth">Growth</span>;
     } else {
      return <span className="cardstyle risk_aggressive">Aggressive</span>;
    }
  };


  return (
    <>
      {show && (
        <div>
          { selectedData?.grade && !module &&
          <>
            <span>
            {selectedData.full_name}'s risk score is {selectedData.score}
            {"  "}
          </span>
          <span className="cardstyle">
            {getBGColorBasedOnGrade(gradeLevel)}
          </span>
          </>
          
  }
    { approvalQuiz && module && (
      <div>
        {selectedData?.quizgrade && 
        <>
        <span>
          {`${card_fields.score}: \u00A0 ${selectedData?.quizscore} \u00A0`}
        </span>
        <span className="cardstyle">
            {`${card_fields.grade}:\u00A0\u00A0`}
            {getBGColorBasedOnGrade(selectedData?.quizgrade)}
          </span>
        </>
        }
      </div>
      )}
       { !approvalQuiz && module && (
      <div>
        {selectedData?.grade && 
        <>
        <span>
          {`${card_fields.score}: \u00A0 ${selectedData?.score} \u00A0`}
        </span>
        <span className="cardstyle">
            {`${card_fields.grade}:\u00A0\u00A0`}
            {getBGColorBasedOnGrade(selectedData?.grade)}
          </span>
        </>
        }
      </div>
      )}
        </div>
      )}
    </>
  );
};

export default Scorefield;
